var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { injectable } from 'inversify';
import { HttpService } from '../http';
import { ValidationService } from '../validation';
import { Calendar } from '../calendar';
import { UnmarshallerService } from '../unmarshaller';
import { GetUnitTypesResponse, GetUnitsTreeResponse, GetUnitChildrenResponse, } from './gen/units';
import { GetCompanyUnitTreeDto, GetUnitTypesDto, GetUnitTreeChildren, GetUnitTreeOptionsDto, } from './dto';
let UnitService = class UnitService {
    constructor(validator, calendar, http, unmarshaller) {
        this.validator = validator;
        this.calendar = calendar;
        this.http = http;
        this.unmarshaller = unmarshaller;
    }
    getUnitTypes(getBatchEmployees) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validator.validateOrReject(getBatchEmployees, GetUnitTypesDto);
            const { companyId } = getBatchEmployees;
            return this.unmarshaller.unmarshall(yield this.http.get(`/company/${companyId}/unit/types`, {}, { withSide: true }), GetUnitTypesResponse);
        });
    }
    getUnitTree(getCompanyUnitTree) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validator.validateOrReject(getCompanyUnitTree, GetCompanyUnitTreeDto);
            const { companyId, unitType, unitId } = getCompanyUnitTree;
            return this.unmarshaller.unmarshall(yield this.http.get(`/company/${companyId}/unit/tree`, Object.assign(Object.assign({}, (unitType && {
                unit_type: unitType,
            })), (unitId && {
                unit_id: unitId,
            })), { withSide: true, reloadIfOldVersion: true }), GetUnitsTreeResponse);
        });
    }
    getBatchUnitTree(getCompanyUnitTree) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validator.validateOrReject(getCompanyUnitTree, GetCompanyUnitTreeDto);
            const { companyId, unitType, unitId } = getCompanyUnitTree;
            return this.unmarshaller.unmarshall(yield this.http.get(`/company/${companyId}/batch/unit/tree`, Object.assign(Object.assign({}, (unitType && {
                unit_type: unitType,
            })), (unitId && {
                unit_id: unitId,
            })), { withSide: true, reloadIfOldVersion: true }), GetUnitsTreeResponse);
        });
    }
    getUnitTreeChildren(dto) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validator.validateOrReject(dto, GetUnitTreeChildren);
            const result = yield this.unmarshaller.unmarshall(yield this.http.get(`/company/${dto.companyId}/unit/${dto.unitId}/children`, {}, { withSide: true }), GetUnitChildrenResponse);
            return result;
        });
    }
    getBatchUnitTreeChildren(dto) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validator.validateOrReject(dto, GetUnitTreeChildren);
            const result = yield this.unmarshaller.unmarshall(yield this.http.get(`/company/${dto.companyId}/batch/unit/${dto.unitId}/children`, {}, { withSide: true }), GetUnitChildrenResponse);
            return result;
        });
    }
    getUnitTreeOptions(getUnitTreeOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validator.validateOrReject(getUnitTreeOptions, GetUnitTreeOptionsDto);
            const result = yield this.http.get('/units/options', getUnitTreeOptions, {
                withSide: true,
            });
            return result;
        });
    }
};
UnitService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [ValidationService,
        Calendar,
        HttpService,
        UnmarshallerService])
], UnitService);
export { UnitService };
